import { BOOKING_URL } from "../../modules/booking/services/booking-service";
import { HttpClient, JSON_STRING } from "../../services/http/http-client";

export const GenreService = {
  findGenres: ({
    section = 'location',
    booking_location_id
  }) => HttpClient.post(BOOKING_URL, {
    action: 'unrelated_genres',
    section,
    booking_location_id,
    output: JSON_STRING
  }),
  insertGenre: ({
    section = 'location',
    genre_name,
    external_id,
    external_table
  }) => HttpClient.post(BOOKING_URL, {
    action: 'new_genre',
    section,
    genre_name,
    external_id,
    external_table,
    output: JSON_STRING,
  }),
  addGenre: ({
    section = 'location',
    external_id,
    genre_id,
    external_table = 'booking_locations'
  }) => {
    return HttpClient.post(BOOKING_URL, {
      action: 'add_remove_genre',
      section,
      external_id,
      genre_id,
      external_table,
    })
  },
  searchGenre: ({
    search,
    booking_location_id,
  }) => HttpClient.post(BOOKING_URL, {
    section: 'location',
    action: 'search_unrelated_genres',
    tableID: 'bl_unrelated_genres',
    output: JSON_STRING,
    search,
    booking_location_id,
  })
}